export * from './air-hole.dto'